import { useFailureToastWithRefresh } from '@flowwai-frontend/bps-officer-web/common/data-access'
import { useCustomT } from '@flowwai-frontend/shared/common-components'
import { getErrorMessageFromErrorType } from '@flowwai-frontend/shared/utils/common'

import { SearchResultType } from '../../../types'

import { GlobalSearchPipelineItemsQuery as Query } from './query.generatedTypes'

interface ReturnType {
   searchResults: SearchResultType[]
   totalCount: number | null
}

const useAPIResponseHandler = (data?: Query): ReturnType => {
   let searchResults: SearchResultType[] = []
   let totalCount: number | null = null

   const { showFailureToastWithRefresh } = useFailureToastWithRefresh()
   const t = useCustomT('globalSearch:searchModal')

   if (!data)
      return {
         searchResults: searchResults,
         totalCount
      }

   const searchResultsData = data.searchPipelineItems

   const onClickRefresh = (): void => {
      window.location.reload()
   }

   switch (searchResultsData.__typename) {
      case 'SearchPipelineItemsResult': {
         totalCount = searchResultsData.totalCount
         searchResults = searchResultsData.pipelineItems.map(pipelineItem => ({
            pipelineItemId: pipelineItem.pipelineItemId,
            name: pipelineItem.name ?? '--',
            stage: pipelineItem.stage || undefined
         }))
         break
      }
      case 'PipelineAccessDenied': {
         const title = t('pipelineAccessDenied.title')
         const message = t('pipelineAccessDenied.description')
         showFailureToastWithRefresh(title, message, onClickRefresh)
         break
      }
      default: {
         const errorMessage = getErrorMessageFromErrorType(
            searchResultsData.__typename
         )
         showFailureToastWithRefresh(errorMessage, '', onClickRefresh)
      }
   }

   return {
      searchResults,
      totalCount
   }
}

export default useAPIResponseHandler
